const InternalUrlHelperPlugin = {
	install (Vue) {
		Vue.prototype.$internalUrl = function (url) {
			url = url.replace(window.dcSite.siteUrl, '')
			if(url.indexOf('/') !== 0) {
				url = '/' + url
			}
			return url
		}
	}
}

export default InternalUrlHelperPlugin